// For trackers from Reddit/Google ads services.

const dictionaryConfigsBots = [
  {
    key: "rdt_cid",
    label: "Reddit ad tracker id",
    type: "string",
    maxLength: 25,
  },
  {
    key: "wbraid",
    type: "string",
    maxLength: 100,
  },
  {
    key: "gclid",
    type: "string",
    maxLength: 100,
  },
];

module.exports = dictionaryConfigsBots;
